module.exports = __webpack_public_path__ + "img/usdt.635dcbe0.svg";